/* Millesève — libellé « Ajouté » pendant 1,4 s après un ajout au panier réussi (DS §13, état Succès ; E2.8).
   Concerne les boutons d'achat qui portent data-ajoute (texte traduit : products.product.ajoute) :
   cartes produit, série des parfums, Enveloppe. Ne touche pas à product-form.js : on retient le formulaire
   envoyé, puis on attend l'événement cartUpdate que product-form.js publie seulement en cas de succès
   (le tiroir du panier s'ouvre comme avant).
   E5.1 : sur ordinateur le bouton passe sous le voile du tiroir, sur mobile le tiroir le couvre. « Ajouté » est donc
   aussi montré dans le tiroir, sur la ligne ajoutée (classe est-ajoute, jusqu'à un changement de quantité ou la fermeture du tiroir), et
   annoncé aux lecteurs d'écran (zone data-panier-statut). setTimeout 0 : product-form.js publie cartUpdate,
   puis remplace le contenu du tiroir (renderContents), puis l'ouvre au tour suivant. */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  const DUREE = 1400;
  let dernier = null;

  /* Ligne ajoutée dans le tiroir. cart.js peut re-rendre la liste juste après l'ouverture (double rendu
     de Dawn) : un observateur repose la marque ; elle s'efface à la fermeture du tiroir. */
  let cleAjoutee = null;
  const marquer = (annoncer) => {
    const tiroir = document.querySelector('cart-drawer');
    if (!tiroir || !cleAjoutee) return;
    const ligne = [...tiroir.querySelectorAll('.cart-item[data-key]')].find((l) => l.dataset.key === cleAjoutee);
    if (!ligne || ligne.classList.contains('est-ajoute')) return;
    ligne.classList.add('est-ajoute');
    const statut = tiroir.querySelector('[data-panier-statut]');
    const marque = ligne.querySelector('.ms-panier__ajoute');
    const nom = ligne.querySelector('.cart-item__name');
    if (annoncer && statut && marque && nom) {
      statut.textContent = `${marque.textContent.trim()} : ${nom.textContent.trim()}`;
    }
  };
  const tiroir = document.querySelector('cart-drawer');
  if (tiroir) {
    new MutationObserver(() => {
      if (!tiroir.classList.contains('active') && !tiroir.classList.contains('animate')) return;
      marquer(false);
    }).observe(tiroir, { childList: true, subtree: true });
    let ouvert = false;
    new MutationObserver(() => {
      const actif = tiroir.classList.contains('active');
      const vientDeFermer = ouvert && !actif;
      ouvert = actif;
      if (!vientDeFermer) return;
      cleAjoutee = null;
      tiroir.querySelectorAll('.est-ajoute').forEach((l) => l.classList.remove('est-ajoute'));
    }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener(
    'submit',
    (e) => {
      const bouton = e.target.closest('product-form')?.querySelector('[type="submit"][data-ajoute]');
      dernier = bouton || null;
    },
    true
  );

  subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
    // quantité changée ou ligne retirée dans le tiroir : la mention « Ajouté » n'a plus lieu d'être
    if (evt && evt.source === 'cart-items') {
      cleAjoutee = null;
      document.querySelectorAll('cart-drawer .est-ajoute').forEach((l) => l.classList.remove('est-ajoute'));
      return;
    }
    if (!evt || evt.source !== 'product-form') return;
    const cle = evt.cartData && evt.cartData.key;
    if (cle) {
      cleAjoutee = cle;
      setTimeout(() => marquer(true));
    }
    if (!dernier) return;
    const bouton = dernier;
    dernier = null;
    const libelle = bouton.querySelector('span');
    if (!libelle) return;
    clearTimeout(bouton._msAjoute);
    if (!bouton.dataset.libelle) bouton.dataset.libelle = libelle.textContent;
    libelle.textContent = bouton.dataset.ajoute;
    bouton._msAjoute = setTimeout(() => {
      libelle.textContent = bouton.dataset.libelle;
      delete bouton.dataset.libelle;
    }, DUREE);
  });
})();
